import { useState } from "react";
import { Loader2, Mail, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AUTH } from "@/constants/testIds";
import { useSession } from "@/context/AuthContext";

export function MagicLinkForm({ label = "Or get a one-time sign-in link" }) {
  const { magicRequest } = useSession();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await magicRequest(email);
      setSent(true);
    } catch {
      setSent(true); // never leak whether the email exists
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-8 border-t border-border/50 pt-6">
      <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{label}</p>
      {sent ? (
        <div data-testid={AUTH.magicSent} className="flex items-start gap-2.5 rounded-lg border border-accent/30 bg-accent/10 px-3.5 py-3 text-sm text-foreground">
          <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-accent" strokeWidth={2.2} />
          <span>If <span className="font-mono text-accent">{email}</span> is valid, a secure sign-in link is on its way. It expires in 15 minutes.</span>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="flex items-center gap-2">
          <div className="relative flex-1">
            <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="email"
              data-testid={AUTH.magicEmail}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="h-11 bg-card/60 pl-9"
            />
          </div>
          <Button
            type="submit"
            disabled={loading || !email}
            data-testid={AUTH.magicSubmit}
            variant="outline"
            className="h-11 rounded-full border-border/80 px-4 font-mono text-xs uppercase tracking-[0.18em] hover:bg-muted"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Email link"}
          </Button>
        </form>
      )}
    </div>
  );
}
